export default "__VITE_ASSET__o$sH7SyW__"